import React from 'react'
import { Link } from 'react-router-dom'
import Iframe from 'react-iframe'
import { useContent } from '../../services'
import analytics from '../../services/analytics'
import bg25 from '../../assets/images/background/bg-25.png'
import bg6 from '../../assets/images/background/bg-6.png'
import restro from '../../assets/images/resource/restaurant.png'

function Contactbanner() {
    const { data, loading } = useContent('contactContent');
    const { data: bizData, loading: bizLoading } = useContent('businessInfo');

    if (loading || !data || bizLoading || !bizData) return null;

    const { contactInfo, messageForm } = data;

    return (
        <>
            <div className="contact-map">
                <Iframe src={data.mapEmbedUrl} width="100%" height="500" frameBorder="0" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></Iframe>
            </div>

            <section className="contact-page">
                <div className="left-bg"><img src={bg25} alt="" title="" /></div>
                <div className="right-bg"><img src={bg6} alt="" title="" /></div>

                <div className="location-center">
                    <div className="auto-container">
                        <div className="cinfo-box">
                            <div className="row clearfix justify-content-center">

                                <div className="contactinfo-block col-lg-5 col-md-5 col-sm-12">
                                    <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="300ms">
                                        <div className="info-icon">
                                            <span className="far fa-clock"></span>
                                        </div>
                                        <h4>{contactInfo.title}</h4>
                                        <div className="text">{contactInfo.line1}</div>
                                        <div className="text highlight">{contactInfo.line2}</div>
                                    </div>
                                </div>

                                <div className="contactinfo-block col-lg-1 col-md-1 d-none d-md-flex align-items-center justify-content-center">
                                    <div className="vertical-divider"></div>
                                </div>

                                <div className="contactinfo-block col-lg-5 col-md-5 col-sm-12">
                                    <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="500ms">
                                        <div className="info-icon">
                                            <span className="far fa-phone"></span>
                                        </div>
                                        <h4>Contact Info</h4>
                                        <div className="text">{bizData.address}</div>
                                        <div className="text">Email : {bizData.email}</div>
                                        <div className="more-link"><Link to={bizData.phoneLink} onClick={() => analytics.trackPhoneClick('contact_page')}>Booking : {bizData.phone}</Link></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="auto-container">
                    <div className="c-page-form-box">
                        <div className="row clearfix">

                            <div className="loc-block col-lg-6 col-md-12 col-sm-12">
                                <div className="title-box centered">
                                    <h2>{messageForm.title}</h2>
                                    <div className="text desc">{messageForm.text}</div>
                                </div>
                                <div className="default-form reservation-form">
                                    <form method="post" action="/" onSubmit={() => analytics.trackContactSubmit()}>
                                        <div className="clearfix">
                                            <div className="form-group">
                                                <div className="field-inner">
                                                    <input type="text" name="fieldname" placeholder="Your Name" required="" />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="field-inner">
                                                    <input type="text" name="fieldname" placeholder="Your Email" required="" />
                                                </div>
                                            </div>
                                            <div className="form-group ">
                                                <div className="field-inner">
                                                    <input type="text" name="fieldname" placeholder="Phone Number" required="" />
                                                </div>
                                            </div>

                                            <div className="form-group ">
                                                <div className="field-inner">
                                                    <textarea name="fieldname" placeholder="Special Request" required=""></textarea>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <button type="submit" className="theme-btn btn-style-one clearfix">
                                                    <span className="btn-wrap">
                                                        <span className="text-one">{messageForm.submitButton}</span>
                                                        <span className="text-two">{messageForm.submitButton}</span>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>


                            <div className="loc-block col-lg-6 col-md-12 col-sm-12">
                                <img src={restro} alt="" />
                            </div>

                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}

export default Contactbanner
